import { render, staticRenderFns } from "./PubDesign.vue?vue&type=template&id=239a7136"
import script from "./PubDesign.vue?vue&type=script&lang=js"
export * from "./PubDesign.vue?vue&type=script&lang=js"
import style0 from "./PubDesign.vue?vue&type=style&index=0&id=239a7136&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports